<!-- @format -->

<div
	*ngIf="personalInformation && personalInformation.loyaltyNumber"
	class="hmf-display-flex hmf-align-items-center"
	[ngClass]="{ 'dcsg-card__border': !abbreviatedVersion }"
	class="scorecard-gold">
	<div
		*ngIf="!abbreviatedVersion"
		class="card-title-group hmf-display-none hmf-display-xlg-flex hmf-display-flex hmf-align-items-center hmf-py-s hmf-justify-content-flex-start px-4 py-1"
		[ngClass]="{ 'gold-member': personalInformation?.isGold }">
		<div class="card-title">Score<span class="card-title__reg">Card</span>&nbsp;Gold</div>

		<img
			class="hmf-display-none hmf-display-lg-inline header gold-flag"
			src="assets/image/gold_flag_header.svg"
			aria-hidden="true"
			*ngIf="personalInformation?.isGold"
			(click)="toggleFireworks()"
			alt="Scorecard Gold Flag Icon" />
	</div>

	<div
		*ngIf="!abbreviatedVersion"
		class="card-title-group hmf-display-xlg-none mobile hmf-display-flex hmf-align-items-center hmf-py-s hmf-justify-content-flex-start px-4 py-1"
		[ngClass]="{ 'gold-member': personalInformation?.isGold }">
		<div class="card-title">Score<span class="card-title__reg">Card</span>&nbsp;Gold</div>
		<img
			class="header gold-flag"
			src="assets/image/gold_flag_header.svg"
			aria-hidden="true"
			*ngIf="personalInformation?.isGold"
			(click)="toggleFireworks()"
			alt="Scorecard Gold Flag Icon" />
	</div>

	<div
		class="pyro"
		*ngIf="showFireworks">
		<div class="before"></div>
		<div class="after"></div>
	</div>

	<div class="gold-card-content">
		<div class="m-4">
			<div class="hmf-display-flex hmf-justify-content-between hmf-align-items-end progress">
				<div>
					<div
						class="progress-header"
						[ngClass]="{ 'abbreviated-header-size': abbreviatedVersion }"
						[innerText]="unlockedStatus"></div>
					<div
						*ngIf="personalInformation?.isGold"
						class="progress-deadline pt-2"
						[innerText]="deadline"></div>
				</div>
				<div
					*ngIf="!personalInformation?.isGold"
					aria-label="You've spent"
					class="progress-header">
					${{ roundedSalesBalance() }}/500
				</div>
			</div>

			<div
				class="gold-progress my-3"
				*ngIf="!personalInformation?.isGold">
				<div class="gold-progress-row hmf-grid hmf-align-items-stretch">
					<div class="hmf-col hmf-span-11 hmf-px-0">
						<img
							class="progress-icon progress-flag"
							[ngStyle]="{ left: balanceProgressCss() }"
							src="assets/image/gold_flag.svg"
							aria-hidden="true"
							*ngIf="finishedAnimating && cappedCurrentYearSales < 500" />
						<mat-progress-bar
							mode="determinate"
							value="{{ balanceProgress() }}"
							aria-hidden="true"
							(animationEnd)="finishGoldBarAnimation($event)">
						</mat-progress-bar>
					</div>
					<div
						class="hmf-col hmf-span-1 hmf-px-0 secondary-bar"
						[ngClass]="{ 'gold-background': cappedCurrentYearSales >= 500 }">
						<img
							class="progress-icon finish-line"
							src="assets/image/race_goal.svg"
							aria-hidden="true" />
					</div>
				</div>
				<br />
				<p
					class="progress-deadline pt-2"
					[innerText]="goldSpendDate"></p>
			</div>

			<div
				*ngIf="
					personalInformation?.isGold &&
					goldExpiresThisYear(personalInformation.tierExpiration)
				">
				<br />
				<hr />
			</div>
			<div
				*ngIf="
					personalInformation?.isGold &&
					goldExpiresThisYear(personalInformation.tierExpiration) &&
					cappedCurrentYearSales < 500
				"
				class="hmf-display-flex hmf-justify-content-between hmf-align-items-end progress">
				<div>
					<br />
					<div class="progress-header">Extend your ScoreCard Gold status</div>
				</div>
				<div
					aria-label="You've spent"
					class="progress-header">
					${{ roundedSalesBalance() }}/500
				</div>
			</div>
			<div
				class="gold-progress my-3"
				*ngIf="
					personalInformation?.isGold &&
					goldExpiresThisYear(personalInformation.tierExpiration) &&
					cappedCurrentYearSales < 500
				">
				<div class="gold-progress-row hmf-grid hmf-align-items-stretch">
					<div class="hmf-col hmf-span-11 hmf-px-0">
						<img
							class="progress-icon progress-flag"
							[ngStyle]="{ left: balanceProgressCss() }"
							src="assets/image/gold_flag.svg"
							aria-hidden="true"
							*ngIf="finishedAnimating && cappedCurrentYearSales < 500" />
						<mat-progress-bar
							mode="determinate"
							value="{{ balanceProgress() }}"
							aria-hidden="true"
							(animationEnd)="finishGoldBarAnimation($event)">
						</mat-progress-bar>
					</div>
					<div
						class="hmf-col hmf-span-1 hmf-px-0 secondary-bar"
						[ngClass]="{ 'gold-background': cappedCurrentYearSales >= 500 }">
						<img
							class="progress-icon finish-line"
							src="assets/image/race_goal.svg"
							aria-hidden="true" />
					</div>
				</div>
				<br />
				<p
					class="progress-deadline pt-2"
					[innerText]="goldExtendDate"></p>
			</div>

			<div
				*ngIf="!personalInformation?.isGold && !abbreviatedVersion"
				class="pt-3 gold-benefits">
				<p class="font-weight-bold gold-benefits__text">Gold Benefits</p>
				<p class="gold-benefits__text">- Pick your 3X points day</p>
				<p class="gold-benefits__text">- Access to Exclusive Member-Only Offers</p>
			</div>
		</div>

		<common-accordion
			#goldExpansionPanel
			*ngIf="personalInformation?.isGold"
			class="gold-expansion-panel"
			[hideHeaderLine]="true"
			[isCollapsed]="true"
			[hideArrowIcon]="true"
			(accordionClicked)="accordionClicked($event)">
			<div
				myPanelHeader
				class="gold-expansion-panel-header hmf-w-100">
				<hr />
				<br />
				<div class="gold-expansion-panel-header__label hmf-text-align-center">
					LEARN MORE
					<div class="gold-expansion-panel-indicator">
						<i
							*ngIf="goldExpansionPanel.isCollapsed"
							class="material-icons">
							<homefield-icon name="chevron-down"></homefield-icon>
						</i>
						<i
							*ngIf="!goldExpansionPanel.isCollapsed"
							class="material-icons">
							<homefield-icon name="chevron-up"></homefield-icon>
						</i>
					</div>
				</div>
			</div>

			<div
				class="gold-expansion-panel-body p-5 hmf-text-align-center"
				myPanelBody>
				<p>
					You've earned Gold status by spending $500+ in a calendar year or by being an
					active ScoreRewards credit card holder, and have unlocked access to members-only
					perks, plus more ways to earn points and Rewards throughout the year. As a
					ScoreCard Gold member, you get 3X points on any purchase once per year. See your
					‘Available Offers’ or visit DICKS.com/ScoreCard for more details. For questions
					regarding your account, contact your dedicated ScoreCard Gold customer service
					team at 1-833-679-9638.
				</p>
			</div>
		</common-accordion>
	</div>
</div>
